export enum DevExtremeFieldTypesEnum {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  DATE = 'date',
  DATE_TIME = 'datetime',
  SELECT = 'select',
  DECIMAL_NUMBER = 'decimal_number'
}
